// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ENDPOINTS } from "@src/constants";
import { RootState } from "@src/rtk/store";
import config from "@src/config";
import { handleRefreshToken } from "@src/rtk/slices/authSlice";
import { AcGetAccessToken, AcGetXUSRToken, AcIsSet } from "@asdf-utils";
import { AcGetTokenType } from "@src/utilities";

const body = {
  grant_type: "refresh_token",
  client_id: process.env.CLIENT_ID,
};
const baseQuery = fetchBaseQuery({
  baseUrl: process.env.API_URL,
  responseHandler: "content-type",
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.access_token;
    const access_token = AcGetAccessToken();
    const token_type = AcGetTokenType() || "Bearer";
    const xuser_token = AcGetXUSRToken();

    if (token) {
      headers.set("authorization", `Bearer ${token}`);

      if (AcIsSet(access_token)) {
        headers.set("authorization", `${token_type} ${access_token}`);
      }

      if (AcIsSet(xuser_token)) {
        headers.set("X-OPP-Merchant-UID", `${xuser_token}`);
      }
    }

    return headers;
  },
});

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${config.pkce.accounts_uri}${ENDPOINTS.AUTH.REFRESH_TOKEN}`,
  }),
  endpoints: (builder) => ({
    refreshAuth: builder.query<void, undefined>({
      queryFn: async (_, api, __, baseQuery) => {
        try {
          const { data } = await baseQuery({
            url: `${config.pkce.accounts_uri}${ENDPOINTS.AUTH.REFRESH_TOKEN}`,
            method: "post",
            body,
            credentials: "include",
          });
          api.dispatch(
            handleRefreshToken(
              data as { access_token: string; expires_in: number }
            )
          );
          return data;
        } catch (e) {
          return e;
        }
      },
    }),
  }),
});
// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
  baseQuery,
  endpoints: () => ({}),
});

export const { useRefreshAuthQuery, useLazyRefreshAuthQuery } = authApi;
